import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import "./EducationalMaterial.css";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";

import { ageRange, pfdContents } from "../helper/getAgeGroup";
import PdfViewer from "./PdfViewer";

const EducationalMaterial = () => {
  const location = useLocation();
  const isPediatrician = location.pathname.includes("pediatrician");
  console.log(isPediatrician);

  const navigate = useNavigate();


  const parentVideoUrl = {
    A: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/afLhXTsjSGo",
        title: "0-3 Mo Development & Intervention",
      },
      {
        url: "https://www.youtube.com/embed/oYv5XzSQhMI",
        title: "NewBorn Care",
      },
      {
        url: "https://www.youtube.com/embed/w1BmhLVWrag",
        title: "0-3 Mo Care & Safety (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/gcEvxqYkkWk",
        title: "0-3 Mo Feeding (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/A8f36yh_McQ",
        title: "0-3 Mo Activities (Bengali)",
      },
    ],
    B: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/mtj-V-6F29M",
        title: "Feeding and Safety",
      },
      {
        url: "https://www.youtube.com/embed/-eFcnCjQiAU",
        title: "3-6 Mo Development & Intervention",
      },
      {
        url: "https://www.youtube.com/embed/ecvCm6QLpEQ",
        title: "3-6 Mo Activity (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/tz7bQA1INCE",
        title: "3-6 Mo Nutrition (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/dxAShoj8alw",
        title: "3-6 Mo Safety (Bengali)",
      },
    ],
    C: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/VfKMQ02iCdc",
        title: "6-9 Mo Development & Intervention",
      },
      {
        url: "https://www.youtube.com/embed/VnIPQoFxumM",
        title: "6-9 Mo Activity (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/4G1vmJWygpw",
        title: "6-9 Mo Nutrition (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/vFbb4fOZHUA",
        title: "6-9 Mo Safety (Bengali)",
      },
      // {
      //   url: "https://www.youtube.com/embed/XAdpDxChdoM?si=GFW09bOX_fOAtbK-",
      //   title: "Video title",
      // },
    ],
    D: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/aci-GD_Eqh0",
        title: "9-12 Mo Development & Intervention",
      },
      {
        url: "https://www.youtube.com/embed/KcL76uBu2-0",
        title: "9-12 Mo Activity (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/Fh0UmaSHtOM",
        title: "9-12 Mo Nutrition (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/JQn6-3F9UMI",
        title: "9-12 Mo Safety (Bengali)",
      },
      // {
      //   url: "https://www.youtube.com/embed/XAdpDxChdoM?si=GFW09bOX_fOAtbK-",
      //   title: "Video title",
      // },
    ],
    E: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/SXBW5P7MHG0",
        title: "12-18 Mo Nutrition Guidance",
      },
      {
        url: "https://www.youtube.com/embed/6Xbd9sf7d8g",
        title: "12-18 Mo Development & Intervention",
      },
      {
        url: "https://www.youtube.com/embed/u5fm2M4rpN0",
        title: "12-18 Mo Activity (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/zrYtTDZhcNk",
        title: "12-18 Mo Nutrition (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/hm6jl8nwB4s",
        title: "12-18 Mo Safety (Bengali)",
      },
    ],
    F: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/-YHO1kRoVgE",
        title: "18-24 Mo Cognitive Development",
      },
      {
        url: "https://www.youtube.com/embed/tNw7Cyq0PDY",
        title: "18-24 Mo Emotional & Language Development",
      },
      {
        url: "https://www.youtube.com/embed/4MQNv1CTfDs",
        title: "18-24 Mo Motor & Safety",
      },
      {
        url: "https://www.youtube.com/embed/yxITliYqhcY",
        title: "18-24 Mo Feeding",
      },
      {
        url: "https://www.youtube.com/embed/O8LTToOxWsc",
        title: "18-24 Mo Safety (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/56LS43QSdQA",
        title: "18-24 Mo Nutrition (Bengali)",
      },
      {
        url: "https://www.youtube.com/embed/xpbBl41A2eI",
        title: "18-24 Mo Activity (Bengali)",
      },
    ],
    G: [
      {
        url: "https://www.youtube.com/embed/6Lv1QvEDH6M",
        title: "How Babies Learn",
      },
      {
        url: "https://www.youtube.com/embed/Zvibna7b3ho",
        title: "What is Early Learning Opportunity",
      },
      {
        url: "https://www.youtube.com/embed/gPbCDBsxUFI",
        title: "24-36 Mo Nutrition",
      },
      {
        url: "https://www.youtube.com/embed/5flMH7yITrs",
        title: "24-36 Mo Play",
      },
      {
        url: "https://www.youtube.com/embed/vBSrCus7OhU",
        title: "24-36 Mo Language Communication",
      },
      {
        url: "https://www.youtube.com/embed/qy_f4Ts_FJY",
        title: "24-36 Mo Motor Skills",
      },
      {
        url: "https://www.youtube.com/embed/sw9uFxnGGx8",
        title: "24-36 Mo Socioemotional",
      },
      {
        url: "https://www.youtube.com/embed/lXYsOvqFOcQ",
        title: "24-36 Months Cognitive and Fine Motor",
      },
    ],
    H: [
      {
        url: "https://www.youtube.com/embed/gPbCDBsxUFI",
        title: "24-30 Mo Nutrition",
      },
      {
        url: "https://www.youtube.com/embed/5flMH7yITrs",
        title: "24-30 Mo Play",
      },
      {
        url: "https://www.youtube.com/embed/vBSrCus7OhU",
        title: "24-30 Mo Language Communication",
      },
      {
        url: "https://www.youtube.com/embed/qy_f4Ts_FJY",
        title: "24-30 Mo Motor Skills",
      },
      {
        url: "https://www.youtube.com/embed/sw9uFxnGGx8",
        title: "24-30 Mo Socioemotional",
      },
      {
        url: "https://www.youtube.com/embed/lXYsOvqFOcQ",
        title: "24-30 Months Cognitive and Fine Motor",
      },
    ],
  };

  const [chilAgeRange, selectAgeRangge] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const handleChange = (e) => {
    selectAgeRangge(e.target.value);
    if (e.target.value) {
      setShowPdf(false);
    }
  };
  function handlePdfChange(content) {
    setPdfUrl(`/pdf/${chilAgeRange}/${content}.pdf`);
    setShowPdf(true);
  }
  function pdfClose() {
    setPdfUrl("");
    setShowPdf(false);
  }

  return (
    <div className="educationalMaterial-container">
      <div className="educationalMaterial-headerContainer">
        <button className="backButton" onClick={() => navigate(-1)}>
          <FontAwesomeIcon className="icon" icon={faArrowLeft} />
          <span>Back</span>
        </button>
        <h1 className="heading">Educational Material</h1>
      </div>
      {!showPdf && (
        <FormControl
          size="small"
          sx={{ width: { xs: "250px", sm: "300px" }, marginTop: "20px" }}
        >
          <InputLabel
            size="small"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // Add styles for the shrunk state
              "&.MuiInputLabel-shrink": {
                transform: "translate(12px, -9px) scale(0.75)",
                maxWidth: "calc(100% - 24px)",
                overflow: "visible",
                textOverflow: "unset",
                background: "white",
                paddingRight: "4px",
                borderRadius: "6px",
              },
            }}
            id="demo-simple-select-label"
          >
            Select Child Age Range
          </InputLabel>
          <Select
            size="small"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={chilAgeRange}
            label="chilild Age Range"
            onChange={handleChange}
          >
            <MenuItem value={""}>Select child Age Range</MenuItem>
            {Object.keys(ageRange).map((item, i) => {
              return (
                <MenuItem key={i} value={item}>
                  {ageRange[item]}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
      {isPediatrician ? (
        <>
          {chilAgeRange && (
            <div className="pdf-container">
              {pfdContents[chilAgeRange].map((content, i) => (
                <div key={i} className="pdf-button">
                  <p>{`${content}`}</p>
                  <button onClick={() => handlePdfChange(content)}>
                    Open PDF
                  </button>
                </div>
              ))}
            </div>
          )}
          {showPdf && chilAgeRange && (
            <PdfViewer onClose={pdfClose} pdfUrl={pdfUrl}/>
          )}
        </>
      ) : (
        <div className="parent-materials">
          {chilAgeRange &&
            parentVideoUrl[chilAgeRange].map((item, index) => (
              <div className="video-card" key={index}>
                <p>{item.title}</p>
                <iframe
                  src={item.url}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                  allowfullscreen
                ></iframe>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
export default EducationalMaterial;